import { useQuery } from '@tanstack/react-query';
import AuthService from 'src/features/auth/data/service/authService';
import { diContainer } from 'src/inversify.config';

const authService = diContainer.get<AuthService>(AuthService);

export const useCheckUserExists = (phoneNumber?: string) => {
  const query = useQuery({
    queryKey: ['checkUserExists', phoneNumber],
    queryFn: () => authService.checkUserExists({ phone_number: phoneNumber! }),
    enabled: !!phoneNumber,
  });

  return { userExists: query.data?.data.user_exists, ...query };
};
